import React from 'react';
import cx from 'classnames';
import Money from '../../components/Money';
import Icon, { GLYPHS } from '../../components/Icon';
import Modal from '../../components/Modal';
import * as shapes from '../../shapes';
import WithToggle from '../../hoc/WithToggle';

const ServiceDetails = ({ service, toggled, on, off }) => (
  <div className="u-fill-parent">
    <div className="o-tableize o-tableize--full o-tableize--fixed o-tableize--middle u-fill-parent">
      <div className="o-tableize__cell u-1/1">
        { service.desc && <div className="c-select-box__controls">
          <div
            role="button"
            className="c-btn c-btn--bare u-inline-block"
            onClickCapture={(e) => {
              e.preventDefault();
              e.stopPropagation();
              on();
            }}
            tabIndex="0"
          >
            <Icon glyph={GLYPHS.INFO} />
          </div>
        </div> }
        <div className={cx('c-service-name u-ph-', { 'u-mt-': !service.duration })}>
          {service.name}
        </div>
        {
          service.duration && (
            <div className="epsilon u-type--bold u--mt--">
              <span className="u-co-white">
                <Money>{ service.cost }</Money>
              </span>
              -
              <span className="u-co-gray-1">{ service.duration } mins</span>
            </div>
          )
        }
        { toggled &&
        <Modal
          close={off}
          size="small"
        >
          <div className="u-co-gray">
            {service.desc}
          </div>
        </Modal>
        }
      </div>
    </div>
  </div>
);
ServiceDetails.propTypes = {
  service: shapes.serviceShape.isRequired,
  toggled: shapes.flag.isRequired,
  on: shapes.handler.isRequired,
  off: shapes.handler.isRequired,
};

export default WithToggle(ServiceDetails);



// WEBPACK FOOTER //
// ./src/app/services/components/ServiceDetails.jsx